/** saves Tabs List
@payload { Array }
*/
export const SAVE_TABS = (state, payload) => {
    state.tabsList = payload.data.favoriteTabs
}

/** saves Favorites List
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
*/
export const SAVE_FAVORITES = (state, { pageNumber, data }) => {
    state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)
    state.favoritesHasMore = state.favoritesList.length < data.total
}

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves Cards List
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
*/
export const SAVE_CARDS = (state, payload) => {
    state.cardsList = payload.data
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.tabsList = []
    state.favoritesList = []
    state.favoritesHasMore = null
}
